import React, {Component} from 'react';

export default class Email extends Component {

    onBlur = (event) => {
        const {
            name,
            label,
        } = this.props.params;

        const value = event.target.value;
        const field = this.props.state.fields[name];

        if (value) {
            if (
                value.indexOf('@') <= 0
                || value.indexOf('.') <= 0
            ) {
                this.props.setField(
                    name,
                    value,
                    `Nem valódi ${label}`,
                );

                return;
            }

            this.props.setField(
                name,
                value,
                '',
            );

            return;
        }

        if (field.role.required) {
            this.props.setField(
                name,
                value,
                'Kötelező megadni',
            );
        }
    };

    onChange = (event) => {
        const value = event.target.value;

        if (
            value.indexOf('<') < 0
            && value.indexOf('>') < 0
        ) {
            this.props.setField(
                this.props.params.name,
                value,
            );
        }
    };

    render() {
        const {
            params,
            state,
        } = this.props;

        const field = state.fields[params.name];

        const hasError = field.error
            ? 'has-error'
            : '';

        return (
            <div
                className={
                    `field field-text ${params.id} ${hasError}`
                }
                style={params.style}
            >
                <div>
                    <label
                        htmlFor={params.id}
                        className={params.classLabel}
                    >
                        {params.label}
                    </label>

                    <input
                        type="text"
                        className={params.classInput}
                        spellCheck="false"
                        autoComplete="off"
                        id={params.id}
                        name={params.name}
                        onBlur={this.onBlur}
                        onChange={this.onChange}
                        value={field.value || ''}
                        disabled={params.disabled}
                    />

                    <p className="help-block help-block-error">
                        {field.error ? (
                            <span className="error">
                                <i className="fa fa-warning" />
                                {' '}
                                {field.error}
                            </span>
                        ) : null}
                    </p>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/fields/Email.js